import React, { useState } from 'react';
import { useEffect } from 'react';
import { Icon, TextInput } from '@sabre/spark-react-core';
import { func, string, object, bool } from 'prop-types';
import useApi from '../../../api-wrapper/use-api.js';
import { URL_NEW_DISTRIBUTION_GROUP_GENERATE } from '../../../end-points.js';
import { handleNonNumberKeyPress } from '../../../utils/common-util.js';
import { DISTRIBUTION_GROUP } from '../../../utils/constants.js';
import { NOTIFICATION_MESSAGES } from '../../../utils/notification-messages.js';

const NewDistributionGroup = ({
   showWarning,
   userName,
   email,
   selectedRowDetails,
   handleDistributionScreenNavigation,
   getDistributionGroupNumber,
   isDistributionNumberApiCall,
}) => {
   const [newDistrubutionGroupConfig, setNewDistributionGroupConfig] = useState(
      {
         distributionGroupNumber: '',
         isTextFocus: false,
      }
   );
   const [keyConfig, setKeyConfig] = useState({
      keyCode: -1,
      ctrl: false,
   });
   const [dgResponse, setDgResponse] = useApi({});

   const newDistributionGroupNumberApiCall = () => {
      setDgResponse({
         method: 'GET',
         url: URL_NEW_DISTRIBUTION_GROUP_GENERATE,
      });
   };

   useEffect(() => {
      document.addEventListener('keydown', handleKeyUp, true);
      return () => {
         document.removeEventListener('keydown', handleKeyUp, true);
      };
   }, []);
   useEffect(() => {
      if (isDistributionNumberApiCall) {
         newDistributionGroupNumberApiCall();
      }
   }, [isDistributionNumberApiCall]);

   useEffect(() => {
      if (
         keyConfig.keyCode === 71 &&
         keyConfig.ctrlKey &&
         (newDistrubutionGroupConfig.isTextFocus ||
            selectedRowDetails.selectedCellIndex >= 0)
      ) {
         newDistributionGroupNumberApiCall();
      }
   }, [keyConfig.keyCode, selectedRowDetails]);

   useEffect(() => {
      if (dgResponse.data.dgNumber) {
         getDistributionGroupNumber(dgResponse.data.dgNumber);
         setNewDistributionGroupConfig({
            distributionGroupNumber: dgResponse.data.dgNumber,
         });
      }
   }, [dgResponse.isLoading]);

   const handleNewDistributionGroupTextChanged = (event, changedValue) => {
      if (changedValue.length <= 6) {
         setNewDistributionGroupConfig({
            ...newDistrubutionGroupConfig,
            distributionGroupNumber: changedValue,
         });
         getDistributionGroupNumber(changedValue);
      } else showWarning(NOTIFICATION_MESSAGES.DISTRIBUTION_NUMBER_MAX_LENGTH);
   };
   const handleKeyUp = (event) => {
      setKeyConfig({
         keyCode: event.keyCode,
         ctrlKey: event.ctrlKey,
      });
      if (event.keyCode === 71 && event.ctrlKey) {
         event.preventDefault();
      }
   };
   const handleNewDistributionGroupNumberCreateClick = () => {
      newDistributionGroupNumberApiCall();
   };
   const handleRedirectDistributionScreen = () => {
      handleDistributionScreenNavigation('Reference', true);
   };
   const handleFocusOrBlurTextBox = (isFocus) => {
      setNewDistributionGroupConfig({
         ...newDistrubutionGroupConfig,
         isTextFocus: isFocus,
      });
   };
   return (
      <div className='new-distribution-group-root-view'>
         <div className='spark-flex justify-end alignment-center'>
            <Icon
               name='resize-max'
               className='spark-pad-t-.5 cursor-pointer'
               size='md'
               style='fill'
               label='distribution-group-open'
               onClick={() => handleRedirectDistributionScreen()}
            />
            <div className='spark-pad-l-1 spark-pad-r-1 spark-bold'>
               {DISTRIBUTION_GROUP}
            </div>
            <div>
               <TextInput
                  onFocus={() => handleFocusOrBlurTextBox(true)}
                  onBlur={() => handleFocusOrBlurTextBox(false)}
                  onKeyPress={(event) => handleNonNumberKeyPress(event)}
                  value={newDistrubutionGroupConfig.distributionGroupNumber}
                  onChange={(event, changedValue) =>
                     handleNewDistributionGroupTextChanged(event, changedValue)
                  }
               >
                  <Icon
                     name='math-add'
                     size='md'
                     style='fill'
                     label='distribution-group-open'
                     onClick={() =>
                        handleNewDistributionGroupNumberCreateClick()
                     }
                  />
               </TextInput>
            </div>
         </div>
      </div>
   );
};

NewDistributionGroup.propTypes = {
   showWarning: func,
   userName: string,
   email: string,
   selectedRowDetails: object,
   handleDistributionScreenNavigation: func,
   getDistributionGroupNumber: func,
   isDistributionNumberApiCall: bool,
};

export default NewDistributionGroup;
